var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: "购物车",
            visible: _vm.drawerVisible,
            size: _vm.getIsMobile ? "100%" : "30%",
          },
          on: {
            close: _vm.handleClose,
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "drawer-table",
              attrs: { data: _vm.data, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "xhname", label: "型号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "source", label: "品牌" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.removeFromDrawer(
                                  row,
                                  $index,
                                  row.channel
                                )
                              },
                            },
                          },
                          [_vm._v(" 删除 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "5px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleQuotation(_vm.data)
                    },
                  },
                },
                [_vm._v("生成")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "5px" },
                  attrs: { type: "danger" },
                  on: { click: _vm.handleClear },
                },
                [_vm._v("清空")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CreateQuotation", {
        attrs: { data: _vm.quotationData, dialog: _vm.quotationDialog },
        on: {
          createQuotation: _vm.createQuotation,
          handleCancel: _vm.handleCancel,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }